module.exports = __webpack_public_path__ + "assets/img/0212.6c644a04.png";